  import { isoToDateString, isoToDateTimeString, monthEnding } from "utils/date";
  
  export default [
  
    { field: 'license', flex: 1, headerName: 'Лицензия' },

    { field: 'name', headerAlign: 'center', headerName: 'Касса', flex: 1, align: 'center',
      valueGetter: (value, row) => `${row.model} - ЗН ${row.factoryNumber}` },
  
    { field: 'duration', flex: 1, headerAlign: 'center', headerName: 'Длительность', align: 'center', 
      valueGetter: (value) => `${value} ${monthEnding(value)}` },

    { field: 'usedAt', headerAlign: 'center', headerName: 'Загружена', flex: 1, align: 'center',
      valueGetter: (value) => isoToDateTimeString(value) },  
      
    { field: 'endActivationAt', headerAlign: 'center', headerName: 'Активация до', flex: 1, align: 'right',
      valueGetter: (value) => value ? isoToDateString(value) : 'активирована' }
  
  ];